/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable react/forbid-prop-types */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import AppLink from '../../shared/components/app-link/AppLink';
import { NAVIGATION_ROUTES } from '../../shared/constants/Constants';

function FlightCancellationQueuesList({ flightCancellations }) {
  const [transactionsList, setTransactionsList] = useState([]);
  const intl = useIntl();
  const formattedMessage = (message) => {
    return intl.formatMessage({ id: message });
  };

  useEffect(() => {
    setTransactionsList(flightCancellations);
  }, [flightCancellations]);

  const getFlightTicket = (txid) => {
    let route = NAVIGATION_ROUTES.FLIGHT.FLIGHT_TICKET_PAGE;
    route = route.replace(':transactionId', txid);
    return route;
  };
  //   const getFlightOrderDetails = (txid) => {
  //     let route = NAVIGATION_ROUTES.FLIGHT.FLIGHT_ORDER_DETAILS;
  //     route = route.replace(':transactionId', txid);
  //     return route;
  //   };
  return (
    <section className="flight-canx-list p-2 ">
      <div className="flight-canx-list_container ms-1">
        <table>
          <thead>
            <tr>
              <th>{formattedMessage('txid')}</th>
              <th>{formattedMessage('txdate')}</th>
              <th>{formattedMessage('ref_txid')}</th>
              <th>{formattedMessage('status')}</th>
              {/* <th>{formattedMessage('details')}</th> */}
              <th>Remarks</th>
            </tr>
          </thead>
          <tbody>
            {transactionsList.map((transaction) => (
              <tr key={transaction.Txid}>
                <td>{transaction.Txid}</td>
                <td>{transaction.TxDate}</td>
                <td>
                  <AppLink
                    linkText={transaction.ReferenceTxid}
                    isLink
                    target="_blank"
                    href={getFlightTicket(transaction.ReferenceTxid)}
                  />
                </td>
                <td>{transaction.Status}</td>
                {/* <td>
                  <AppLink
                    linkText={formattedMessage('details')}
                    isLink
                    target="_blank"
                    href={getFlightOrderDetails(transaction.ReferenceTxid)}
                  />
                </td> */}
                <td>{transaction.Remarks}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </section>
  );
}
FlightCancellationQueuesList.propTypes = {
  flightCancellations: PropTypes.array.isRequired,
};

export default FlightCancellationQueuesList;
